module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "home_part_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "home_part_2"
  }, [_c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("成本控制")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("云服务器")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("快速开发")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("安全稳定")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_item"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("专业设计")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("量身定制，昂科科技为您控制底开发成本")])])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_3"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("关于我们")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("全面人性化服务+优秀技术研发团队")]), _vm._v(" "), _c('div', {
    staticClass: "img"
  }), _vm._v(" "), _c('div', {
    staticClass: "content_title"
  }, [_vm._v("江西聚小宝科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "content_des"
  }, [_vm._v("江西聚小宝科技有限公司是一家集软件自主研发、运营、维护及服务为一体的技术型公司。形成了内部管理体系、行政审批系统、电子商务管理系统、安全监测管理系统、微信二次开发管理系统等主要产品。并向客户提供专家团队的咨询服务、定制服务、运维服务。我们注重产品质量和优质服务，本着“务实创新，追求卓越”的核心价值观服务客户。")])]), _vm._v(" "), _c('div', {
    staticClass: "home_part_4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("为什么选择我们")]), _vm._v(" "), _c('div', {
    staticClass: "smalltitle"
  }, [_vm._v("全面人性化服务+优秀技术研发团队")]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "279px",
      "left": "220px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_2.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更短开发周期")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "279px",
      "left": "980px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_1.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更低产开发成本")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "539px",
      "left": "220px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_3.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更高产品质量")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "top": "539px",
      "left": "980px"
    }
  }, [_c('div', {
    staticClass: "img",
    staticStyle: {
      "background": "url('/static/img/fz_item_4.png')"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("更好安全性能")]), _vm._v(" "), _c('div', {
    staticClass: "des"
  }, [_vm._v("软件服务是一种把管理软件和实施服务一体化打包的软件服务模式，\n        它包括提供成熟的软件产品、优质的实施培训服务等。软件服务是\n        一种把管理软件和实施服务一体化打包的软件服务模式，它包括提\n        供成熟的软件产品、优质的实施培训服务等。\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc95e1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 21
// module chunks = 0